module.exports = "/images/logo.svg?485f97cfcabaed7f5c65b4787e82bfd2";